/* eslint-disable no-use-before-define */
/* global RegionConfig */

import {Children, cloneElement, useMemo} from 'react';
import {getArea, getCenter} from 'ol/extent';

import register, {ProjectionType, EPSG4326, getLCCProjectionName} from 'topmeteo/flight-planning/utils/projection';

register(RegionConfig);

const RegionType = {
    Continent: 'continent',
    Country: 'country',
    Region: 'region',
};

const CentralEurope = 'me';

const Depths = {
    [RegionType.Continent]: 1,
    [CentralEurope]: 2,
    [RegionType.Country]: 3,
    [RegionType.Region]: 4,
};

const getDepth = region => Depths[region.id] || Depths[region.type] || 5;

const convertRegion = region => {
    const {projection, children} = region;
    const {extent, type} = projection;
    const projectionName = type === ProjectionType.LCC ? getLCCProjectionName(region.id) : EPSG4326;
    const center = getCenter(extent);
    const area = getArea(extent);
    const depth = getDepth(region);

    return [{...region, projectionName, extent, center, area, depth}, ...convertRegions(children)];
};

const convertRegions = regions => regions.flatMap(convertRegion);

const Regions = convertRegions(RegionConfig);

const prepareRegions = images => Regions
    .map(region => ({...region, url: images[region.id] || null}))
    .filter(({url}) => url);

const RegionProvider = ({images, children}) => {
    const child = Children.only(children);
    const preparedRegions = useMemo(() => prepareRegions(images), [images]);

    return cloneElement(child, {regions: preparedRegions});
};

export default RegionProvider;
